import auth from '../auth/auth'
import gen from '../gen'
import firebase from 'firebase/app'
import 'firebase/auth'

const state = {
  userDetails_displayName: '',
  userDetails_email: '',
  userDetails_photoURL : '', //thumbnail
  //
  userDetails_profilePicUrl : ''
}

const getters = {

}

const mutations = {
  //
  getUserDetails(state2){
    //
    gen.state.loader = true
    //
    //get from session
    state.userDetails_displayName = auth.state.user.displayName
    state.userDetails_email = auth.state.user.email
    state.userDetails_photoURL = auth.state.user.photoURL
    //
    gen
      .actions
      .getDataFromDoc(state, {
        dbPath: 'users/' + auth.state.user.uid
      }).then((userDoc)=>{
      //
      if(userDoc.exists){ //may not exits if user has not uploaded a pic.
        //
        state.userDetails_profilePicUrl =  userDoc.data().picUrl
        //
        window.thisOfVueComp.$forceUpdate()
        //
      }
      gen.state.loader = false
      //
    })
  },
  //
  updateUserDetails(state2, payload){
    //
    let displayName = payload.displayName
    //
    gen.state.btnLoader = true
    //
    var user = firebase.auth().currentUser;
    //
    user.updateProfile({
      displayName
    }).then(function() {
      //
      gen.mutations.snackbar_alert(state, {
        msg: 'Profile Detail Updated !'
      })
      //
      state.userDetails_displayName = payload.displayName
      //
      gen.state.btnLoader = false
      //
      window.thisOfVueComp.$forceUpdate()
      window.thisOfHeader.$forceUpdate()
      //
    }).catch(function(error) {
      console.log("[profile detail update] // An error happened.", error)
    })
    //
  },
  //
}

const actions = {

}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/user/userDetails.js